import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import { openEditRoamingDeviceModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useEditRoamingDeviceMenuItem = (identifier) => {
  const dispatch = useDispatch();

  return {
    id: "move-roaming-device",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-pencil" />
        <span>
          <FormattedMessage id="edit_info" />
        </span>
      </Fragment>
    ),
    disabled: false,
    action: () => {
      dispatch(openEditRoamingDeviceModal(identifier));
    },
  };
};

export const EditRoamingDeviceDropdownItem = ({ identifier, ...props }) => {
  const { id, content, disabled, action } =
    useEditRoamingDeviceMenuItem(identifier);

  return (
    <LazyLoadDropdownItem
      id={id}
      disabled={disabled}
      action={action}
      {...props}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const EditRoamingDeviceModalItem = ({ identifier }) => {
  const { id, content, disabled, action } =
    useEditRoamingDeviceMenuItem(identifier);

  return (
    <DeviceActionsModalItem id={id} disabled={disabled} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
